export default __webpack_public_path__ + "static/media/Wolox.e9be6591.webp";